module.exports = __webpack_public_path__ + "img/icon-building-dark.17292f6e.svg";